module.exports = __webpack_public_path__ + "media/2-5 如何过春节.27dec716.mp4";